import { createSlice } from '@reduxjs/toolkit';

import {
  AstSignMailHandoffStatus,
  type AstSignMailState,
} from 'features/ast-signmail/interfaces';

export const initialAstSignMailState: AstSignMailState = {
  handoffStatus: AstSignMailHandoffStatus.INACTIVE,
};

export const astSignMailSlice = createSlice({
  name: 'astSignMail',
  initialState: initialAstSignMailState,
  reducers: {
    startAstSignMailHandoff: (state) => {
      state.handoffStatus = AstSignMailHandoffStatus.SHOWING;
    },
    endAstSignMailHandoff: (state) => {
      state.handoffStatus = AstSignMailHandoffStatus.INACTIVE;
    },
  },
});

export const { startAstSignMailHandoff, endAstSignMailHandoff } =
  astSignMailSlice.actions;

export const astSignMailReducer = astSignMailSlice.reducer;
